import React from "react";
import {Alert, capitalize, Chip} from "@mui/material";
import {Toolbar, ToolbarButton} from "@mui/x-data-grid";
import {
    ColumnsPanelTrigger,
    FilterPanelTrigger,
    GRID_ROW_GROUPING_SINGLE_GROUPING_FIELD,
    gridColumnLookupSelector,
    useGridApiContext,
    useGridSelector,
} from "@mui/x-data-grid-premium";
import {observer} from "mobx-react-lite";
import {
    CAT_EQ_OPERATOR,
    CAT_NEQ_OPERATOR
} from "../../categorization/components/review-table/review-table-muix/filters/CategoryFilter.tsx";
import {useStores} from "../../../stores";
import Tooltip from "@mui/material/Tooltip";
import Stack from "@mui/material/Stack";
import FilterListIcon from '@mui/icons-material/FilterList';
import WidthwideIcon from '../../../components/icons/svg/WidhtwideIcon.svg?react';
import ViewColumnIcon from '../../../components/icons/svg/ViewColumnIcon.svg?react';
import RefreshIcon from '../../../components/icons/svg/RefreshIcon.svg?react';
import {DataGridHeaderFiltersToggleButton} from '~/components/data-grid/DataGridHeaderFiltersToggleButton';

/**
 * Taken from https://mui.com/x/react-data-grid/components/toolbar/#filter-bar
 */
export const GRToolbar: React.FC<{
    headerFiltersVisible?: boolean;
    onToggleHeaderFilters?: () => void;
}> = observer(({headerFiltersVisible = false, onToggleHeaderFilters}) => {
    const {p, goldenRecordStore} = useStores()
    const apiRef = useGridApiContext();
    const tableController = goldenRecordStore.grPageController.tableController;
    const filterController = goldenRecordStore.grPageController.filterController;
    const columns = useGridSelector(apiRef, gridColumnLookupSelector);
    // noinspection TypeScriptValidateTypes
    // const groupingPanelTriggerRef = React.useRef<HTMLButtonElement>(null);
    // const [groupingPanelOpen, setGroupingPanelOpen] = React.useState(false);

    return <Toolbar>
        {/*<Tooltip title="Grouping">*/}
        {/*    <ToolbarButton*/}
        {/*        ref={groupingPanelTriggerRef}*/}
        {/*        aria-describedby="grouping-panel"*/}
        {/*        onClick={() => setGroupingPanelOpen(!groupingPanelOpen)}*/}
        {/*    >*/}
        {/*        <TableChartIcon fontSize="small" className="m-1"/>*/}
        {/*    </ToolbarButton>*/}
        {/*</Tooltip>*/}
        {/*<Popper*/}
        {/*    open={groupingPanelOpen}*/}
        {/*    anchorEl={groupingPanelTriggerRef.current}*/}
        {/*    placement="bottom-start"*/}
        {/*    id="grouping-panel"*/}
        {/*>*/}
        {/*    <ClickAwayListener onClickAway={() => setGroupingPanelOpen(false)}>*/}
        {/*        <Paper elevation={8} style={{maxHeight: '50vh', overflow: 'scroll'}}>*/}
        {/*            <List>*/}
        {/*                {tableController.tableColumns.filter(col => !!col.groupable && !col.disableColumnMenu).map(col => {*/}
        {/*                        const checked = tableController.rowGroupingModel.includes(col.field);*/}
        {/*                        return <ListItem key={col.field} className='p-0'>*/}
        {/*                            <ListItemButton role='button' dense className='px-0.5 py-0'*/}
        {/*                                            onClick={() => checked ?*/}
        {/*                                                tableController.removeGroupingCol(col.field) :*/}
        {/*                                                tableController.addGroupingCol(col.field)}>*/}
        {/*                                <ListItemIcon>*/}
        {/*                                    <Checkbox*/}
        {/*                                        edge="start"*/}
        {/*                                        checked={tableController.rowGroupingModel.includes(col.field)}*/}
        {/*                                        tabIndex={-1}*/}
        {/*                                        slotProps={{input: {'aria-labelledby': 'checkbox-list-label-' + col.field}}}*/}
        {/*                                    />*/}
        {/*                                </ListItemIcon>*/}
        {/*                                <ListItemText id={col.field} primary={col.headerName}/>*/}
        {/*                            </ListItemButton>*/}
        {/*                        </ListItem>*/}
        {/*                    }*/}
        {/*                )}*/}
        {/*            </List>*/}
        {/*        </Paper>*/}
        {/*    </ClickAwayListener>*/}
        {/*</Popper>*/}
        {/*<Stack direction='row' divider={<NavigateNext fontSize='small' className='my-auto'/>} className='me-4'>*/}
        {/*    {tableController.rowGroupingModel.map((grouping_col) => {*/}
        {/*        let headerName = columns[grouping_col]?.headerName ?? '';*/}
        {/*        if (grouping_col === 'goldenrecordpartproperty__value' && filterController.property_types)*/}
        {/*            headerName += ' ' + filterController.property_types.filter(*/}
        {/*                cpt => cpt.selected*/}
        {/*            ).map(*/}
        {/*                cpt => cpt.type.name*/}
        {/*            ).join(', ');*/}
        {/*        return <Chip*/}
        {/*            key={grouping_col}*/}
        {/*            label={headerName}*/}
        {/*            onDelete={() => {*/}
        {/*                if (grouping_col === 'goldenrecordpartproperty__value')*/}
        {/*                    // This will call removeGroupingCol*/}
        {/*                    filterController.property_types.filter(cpt => cpt.selected).forEach(cpt =>*/}
        {/*                        filterController.setSelectedPropertyType(cpt.id, false));*/}
        {/*                else*/}
        {/*                    tableController.removeGroupingCol(grouping_col);*/}
        {/*            }}*/}
        {/*        />;*/}
        {/*    })}*/}
        {/*</Stack>*/}

        {onToggleHeaderFilters && (
            <DataGridHeaderFiltersToggleButton
                visible={headerFiltersVisible}
                onToggle={onToggleHeaderFilters}
            />
        )}
        <Tooltip title="Filters">
            <FilterPanelTrigger render={<ToolbarButton/>}>
                <FilterListIcon fontSize="small"/>
            </FilterPanelTrigger>
        </Tooltip>

        <Stack direction="row" sx={{gap: 0.5, flex: 1}}>
            {filterController.gridFilterModel.items.filter(
                f => f?.value && f.field !== 'harmonized_name' 
            ).map((filter) => {
                const column = columns[filter.field];
                const fieldName = (
                    filter.field === GRID_ROW_GROUPING_SINGLE_GROUPING_FIELD
                        ? p.supplierDataName // Columns might not be loaded immediately, so we use the profileStore here...
                        : (column?.headerName ?? filter.field)
                );

                let operator = '';
                let label: string;

                if (filter.operator === CAT_EQ_OPERATOR.operatorValue) {
                    // noinspection TypeScriptUnresolvedReference
                    operator = apiRef.current.getLocaleText('filterOperatorEquals');
                    label = `${fieldName} ${operator} previous`;
                } else if (filter.operator === CAT_NEQ_OPERATOR.operatorValue) {
                    // noinspection TypeScriptUnresolvedReference
                    operator = apiRef.current.getLocaleText('filterOperatorDoesNotEqual');
                    label = `${fieldName} ${operator} previous`;
                } else if (filter.operator === 'between') {
                    // To avoid missing translation
                    // See https://github.com/mui/mui-x/issues/13217
                    const lowerBound = String(Number(filter.value?.at(0) ?? 0) * 100) + ' <= ';
                    const upperBound = ' <= ' + String(Number(filter.value?.at(1) ?? 0) * 100);
                    label = `${filter.value?.at(0) ? lowerBound : ''}${fieldName}${filter.value?.at(1) ? upperBound : ''}`;
                } else {
                    const lookup = `filterOperator${capitalize(filter.operator)}` as 'filterOperatorContains';
                    // noinspection TypeScriptUnresolvedReference
                    operator = apiRef.current.getLocaleText(lookup);
                    label = `${fieldName} ${operator} ${filter.value ?? ''}`;
                }

                return <Chip
                    key={filter.id}
                    label={label}
                    onDelete={() => filterController.removeFilter(filter.id)}
                    className="ms-1"
                />;
            })}
        </Stack>

        {(tableController.sortModel.length === 0) && <Alert severity="info">
            No sorting is specified!&nbsp;
            {((tableController.defaultSortModel?.length ?? 0) > 0) && <span>Default is
                {tableController.defaultSortModel?.map(si => <b>
                    {tableController.tableColumns.find(c => c.field === si.field)?.headerName ?? ''}
                    &nbsp;
                    {si.sort === 'desc' ? 'Descending' : 'Ascending'}
                </b>)}
            </span>}
        </Alert>}

        <Tooltip title="Auto size columns">
            <ToolbarButton onClick={() => tableController.setAutoResize(!tableController.autoResize)}>
                <WidthwideIcon color={tableController.autoResize ? '#1A1B20' : 'disabled'}/>
            </ToolbarButton>
        </Tooltip>

        <Tooltip title="Change columns">
            <ColumnsPanelTrigger aria-label="gr-column-panel-trigger" render={<ToolbarButton/>}>
                <ViewColumnIcon color="#1A1B20"/>
            </ColumnsPanelTrigger>
        </Tooltip>


        <Tooltip title="Refresh data">
            <ToolbarButton onClick={() => tableController.resetRowState(true)}>
                <RefreshIcon color="#1A1B20" width={24} height={24}/>
            </ToolbarButton>
        </Tooltip>
    </Toolbar>;
});